import DefaultColumnFilter from "./filters/DefaultColumnFilter";
import RowNavigationCell from "../components/cell/RowNavigationCell";
import DateColumnFilter from "./filters/DateColumnFilter";
import CreationDataCell from "../components/cell/CreationDataCell";
import BlueprintIcon from "../components/cell/BlueprintIcon";
import { BLANK_VALUE } from "./filters/MultipleSelectionFilter/MultipleSelectionFilterValues";
import moment from "moment";
import EnvironmentStatus from "../components/cell/EnvironmentStatus";
import BlueprintTableCell from "../../../adminPage/blueprint/blueprintsResultsTable/BlueprintTableCell";
import RowIconsCell from "../../../adminPage/blueprint/blueprintsResultsTable/RowIconsCell";
import GeneralColumnCell from "../../../adminPage/blueprint/blueprintsResultsTable/GeneralColumnCell";


const defaultFiltering = (rows, columnIds, filterObject) => {
  const { freeText, multipleSelection } = filterObject;
  const column = columnIds[0];
  let result = [...rows];
  if (multipleSelection) {
    result = result.filter((row) => {
      if(column === 'userRole'){
        if (multipleSelection.includes(BLANK_VALUE)) return !row.values[column];
        return multipleSelection[0].name.includes(row.values[column]?.name);
      }
      else{
        if (multipleSelection.includes(BLANK_VALUE)) return !row.values[column];
        console.log(row.values[column],multipleSelection.includes(row.values[column]))
        return multipleSelection.includes(row.values[column]);
      }
    });
  }
  if (freeText) {
    result = result.filter((row) =>{
      if(typeof row.values[column] === "string"){
        return row.values[column].toLowerCase().includes(freeText.toLowerCase());
      }else if(typeof row.values[column] === "number" || typeof row.values[column] === "boolean"){
        return  row.values[column].toString().includes(freeText.toLowerCase());
      }
      else if(typeof row.values[column] === "object"){
        return  row.values[column]?.name.toLowerCase().includes(freeText.toLowerCase());
      }
      else return false;
    })
  }

  return result;
};

export const config = {
  columns: [
    {
      Header: "",
      accessor: "categoryId",
      id: "category-id",
      Filter: DefaultColumnFilter,
      Cell: BlueprintIcon,
      disableFilters: true,
      width: "3%",
    },

    {
      Header: "BluePrint",
      accessor: "blueprint",
      id: "blueprint",
      Filter: (props) => (
        <DefaultColumnFilter {...props} enableMultipleSelection />
      ),
      filter: defaultFiltering,
      width: "40%",
    },
    {
      Header: "Customer Name",
      accessor: "customerName",
      id: "customer-name",
      Filter: (props) => (
        <DefaultColumnFilter {...props} enableMultipleSelection />
      ),
      filter: defaultFiltering,
      width: "15%",
    },
    {
      Header: "Creation Date",
      accessor: "createdOn",
      width: "15%",
      id: "creation-date",
      Filter: DateColumnFilter,
      Cell: CreationDataCell,
      filter: (rows, columnIds, filterObject) => {
        return rows.filter((row) => {
          const column = columnIds[0];
          const date = row.values[column];
          const formattedDate = moment(date).format("YYYY-MM-DD");
          return formattedDate.includes(filterObject);
        });
      },
    },
    {
      Header: "Status",
      accessor: "status",
      id: "status",
      Filter: (props) => (
          <DefaultColumnFilter {...props} enableMultipleSelection />
      ),
      filter: defaultFiltering,
      Cell: (props) => <EnvironmentStatus {...props}/>,
      width: "9%",
    },
    {
      Header: "",
      accessor: "icons",
      id: "icons",
      Filter: DefaultColumnFilter,
      disableFilters: true,
      Cell: (props) => <RowNavigationCell {...props} />,
      width: "auto",
      disableSortBy: true,
    },
  ],
};

export const configBlueprintTable = {
  columns: [
    {
      Header: "Blueprint",
      accessor: "name",
      id: "name",
      disableFilters: false,
      Cell: ({row}) => {
        return (<BlueprintTableCell bp={row.original}/>)
      },
      Filter: (props) => (
          <DefaultColumnFilter {...props} enableMultipleSelection/>
      ),
      filter: defaultFiltering,
      width: "30%",
      disableSortBy: true,
    },
    {
      Header: "Active",
      accessor: "active",
      id: "active",
      Filter: (props) => (
          <DefaultColumnFilter {...props}  enableMultipleSelection/>
      ),
      filter: defaultFiltering,
      Cell: ({row}) =>{
        let active=row.original.active?.toString() || "";
        return <GeneralColumnCell data={active}/>
      } ,
      width: "7%",
    },
    {
      Header: "Duration",
      accessor: "duration",
      id: "duration",
      Filter: (props) => (
          <DefaultColumnFilter {...props}  enableMultipleSelection/>
      ),
      filter: defaultFiltering,
      Cell: ({row}) =>  <GeneralColumnCell data={row.original.duration}/>,
      width: "7%",
    },
    {
      Header: "Sub Pillar",
      accessor: "subPillar",
      id: "subPillar",
      Filter: (props) => (
          <DefaultColumnFilter {...props} enableMultipleSelection />
      ),
      filter: defaultFiltering,
      Cell: ({row}) => <GeneralColumnCell data={row.original.subPillar}/>,
      width: "12%",
    },
    {
      Header: "User Role",
      accessor: "userRole",
      id: "userRole",
      Filter: (props) => (
          <DefaultColumnFilter {...props} enableMultipleSelection />
      ),
      filter: defaultFiltering,
      Cell: ({row}) => <GeneralColumnCell data={row.original.userRole.name}/>,
      width: "15%",
    },
    {
      Header: " Cloud Type ",
      accessor: "cloudType",
      id: "cloudType",
      Filter: (props) => (
          <DefaultColumnFilter {...props}  enableMultipleSelection/>
      ),
      filter: defaultFiltering,
      Cell: ({row}) =>{
        return  <GeneralColumnCell data={row.original.cloudType}  />
      },
      width: "10%",
    },
    {
      Header: " Priority ",
      accessor: "priority",
      id: "priority",
      Filter: (props) => (
          <DefaultColumnFilter {...props}  enableMultipleSelection/>
      ),
      filter: defaultFiltering,
      Cell: ({row}) =>{
        return  <GeneralColumnCell data={row.original.priority}  />
      },
      width: "8%",
    },
    {
      Header: "",
      accessor: "icons",
      id: "icons",
      Filter: DefaultColumnFilter,
      disableFilters: true,
      Cell: ({row}) => <RowIconsCell bp={row.original} />,
      width: "auto",
      disableSortBy: true,
    },
  ],
};
